"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _api = require("./api");
var _enum = require("../enum");
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var suplierCouponsApi = _interopRequireWildcard(require("@/api/suplierCouponsApi.js"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var _default = exports.default = {
  data: function data() {
    return {
      operationPlatform: [],
      //运营平台
      miniProgramCustomer: false,
      //是否为小程序客户
      //弹窗
      AddCouponVueRef: null,
      CapitalAllocationVueRef: null,
      DeleteCouponVueRef: null,
      cooperationStatusEnum: _enum.cooperationStatusEnum,
      // 运营方式
      platformTypeEnum: _enum.platformTypeEnum,
      grid: {
        xl: 8,
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
      },
      tableData: {
        list: [],
        total: 0
      },
      pageFrom: {
        page: 1,
        limit: 15
      },
      searchOptions: [],
      searchLoading: false,
      collapse: false,
      labelLists: [],
      loading: false,
      // 表格loading
      userOption: [],
      dialogVisible: false,
      //毛利配置
      customerId: '',
      supplyPriceValueReta: '',
      supplyPriceValueSup: '',
      customerPriceValueReta: '',
      customerPriceValueSup: '',
      brandNew: '',
      radio: '',
      activeName: '',
      grossMargin: null,
      grossMarginEnd: null,
      rateListArr: [],
      brand: null,
      brandKfc: null,
      ljcType: null
    };
  },
  methods: {
    throttle: _throttle.default,
    search: function search() {
      this.pageFrom.page = 1;
      this.getList();
    },
    getOperationPlatform: function getOperationPlatform() {
      var _this = this;
      suplierCouponsApi.getOperationPlatform().then(function (data) {
        console.log("运营平台数据", data);
        _this.operationPlatform = data;
        console.log("运营平台数据", _this.operationPlatform);
      });
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pageFrom.limit = size;
      this.getList();
    },
    pageChange: function pageChange(page) {
      this.pageFrom.page = page;
      this.getList();
    },
    // 归属公司
    remoteMethod: function remoteMethod(query) {
      var _this2 = this;
      this.searchLoading = true;
      (0, _api.getCompanyListApi)(query).then(function (res) {
        _this2.searchOptions = res.total ? res.list : res;
        _this2.searchLoading = false;
      }).catch(function () {
        _this2.$message.error('请求失败，请稍后再试');
        _this2.searchLoading = false;
      });
    },
    handleCheckAllChange: function handleCheckAllChange() {},
    handleCheckedCitiesChange: function handleCheckedCitiesChange() {},
    //新增/编辑客户
    AddCoupon: function AddCoupon(type) {
      console.log(this.tableData.list);
      console.log("type>>", type);
      this.AddCouponVueRef.open(type);
    },
    // 资金记录
    CapitalAllocation: function CapitalAllocation(row) {
      this.CapitalAllocationVueRef.open(row);
    },
    // 删除记录
    DeleteRecode: function DeleteRecode(id) {
      this.DeleteCouponVueRef.open(id);
    },
    // 列表
    getList: function getList() {
      var _this3 = this;
      this.loading = true;
      var params = _objectSpread(_objectSpread({}, this.pageFrom), {}, {
        customerType: 3
      });
      (0, _api.getCustomersApi)(params).then(function (res) {
        _this3.tableData = res;
        console.log("tableData......", _this3.tableData);
        console.log("res......", res);
        _this3.loading = false;
      }).catch(function (err) {
        _this3.loading = false;
      });
    },
    //跳转页面
    goDistributor: function goDistributor(row, url) {
      this.$router.push({
        path: url,
        query: {
          id: row.id,
          name: row.name
        }
      });
    },
    // 三方商品授权
    settingThdGoods: function settingThdGoods() {
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.$router.push({
        path: '/business/clientManage/jingdongGoods',
        query: {
          id: row.id,
          name: row.name
        }
      });
    },
    handleUserSearch: function handleUserSearch(data) {
      var _this4 = this;
      this.throttle(function () {
        _this4.getSelectUser(data);
      }, 300)();
    },
    // 查询当前登陆人
    getSelectUser: function getSelectUser(keyWord) {
      var _this5 = this;
      this.userOption = [];
      suplierCouponsApi.getAllUser(keyWord).then(function (res) {
        _this5.userOption = res || []; //flag: 1表示当前登陆人
      });
    },
    reltScopeObj: function reltScopeObj(row) {
      var _this6 = this;
      this.supplyPriceValueReta = '';
      this.supplyPriceValueSup = '';
      this.customerPriceValueReta = '';
      this.customerPriceValueSup = '';
      this.dialogVisible = true;
      (0, _api.getRateListApi)({
        customerId: row.id
      }).then(function (res) {
        _this6.rateListArr = res;
        _this6.rateListArr.forEach(function (item) {
          if (item.typeName === '电影') {
            item.filmRate.supplyPriceType === 2 ? _this6.supplyPriceValueReta = item.filmRate.supplyPriceValue : item.filmRate.supplyPriceType === 3 ? _this6.supplyPriceValueSup = item.filmRate.supplyPriceValue : 0;
            item.filmRate.customerPriceType === 2 ? _this6.customerPriceValueReta = item.filmRate.customerPriceValue : item.filmRate.customerPriceType === 3 ? _this6.customerPriceValueSup = item.filmRate.customerPriceValue : 0;
          }
        });
        _this6.customerId = row.id;
      });
    },
    handleRelatEdit: function handleRelatEdit() {
      var _this7 = this;
      this.rateListArr = this.rateListArr.map(function (item) {
        if (item.typeName === '电影') {
          var supplyPriceValue = item.filmRate.supplyPriceType === 2 ? _this7.supplyPriceValueReta : item.filmRate.supplyPriceType === 3 ? _this7.supplyPriceValueSup : 0;
          var customerPriceValue = item.filmRate.customerPriceType === 2 ? _this7.customerPriceValueReta : item.filmRate.customerPriceType === 3 ? _this7.customerPriceValueSup : 0;
          return _objectSpread(_objectSpread({}, item), {}, {
            filmRate: _objectSpread(_objectSpread({}, item.filmRate), {}, {
              supplyPriceValue: supplyPriceValue,
              customerPriceValue: customerPriceValue
            })
          });
        }
        return item;
      });
      (0, _api.getRateEdit)({
        rateList: this.rateListArr,
        customerId: this.customerId
      }).then(function (res) {
        _this7.$message.success('修改成功');
        _this7.dialogVisible = false;
        _this7.getList();
      });
    },
    handleEditNew: function handleEditNew(item) {
      var _this8 = this;
      item.rate.map(function (item) {
        item.grossMargin = _this8.brandNew;
        return item;
      });
    }
  },
  created: function created() {
    if (this.$getHomeType()) {
      this.ljcType = this.$getHomeType().ljcType;
      console.log("this.ljcType>>>>>>>>>>>", this.ljcType);
    }
    this.remoteMethod();
    this.getList();
    this.getSelectUser();
    this.miniProgramCustomer = suplierCouponsApi.getHomeType();
  },
  mounted: function mounted() {
    this.AddCouponVueRef = this.$refs.AddCouponVueRef;
    this.CapitalAllocationVueRef = this.$refs.CapitalAllocationVueRef;
    this.DeleteCouponVueRef = this.$refs.DeleteCouponVueRef;
    this.getOperationPlatform();
  }
};